import { Reveal } from "@components/ui";
import rectangleImg from "@assets/images/Rectangle-54@2x.png";

const checkpoints = [
  "Supporting UAE Net Zero 2050 Strategy",
  "Contributing to Dubai Clean Energy Strategy",
  "Integrating energy-efficient technologies",
  "Safe and sustainable energy supply",
];

const ClimateVisionSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px] bg-[#f9f9fb]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Text column */}
          <Reveal>
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#1a7a4f]/10 text-[#1a7a4f] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
                National Alignment
              </span>
              <h2 className="text-[28px] md:text-[44px] lg:text-[52px] tracking-[-0.04em] font-semibold text-[#122d63] mb-4">
                Aligned With the Nation's Climate Vision
              </h2>
              <p className="text-[16px] md:text-[20px] text-[#62636c] tracking-[-0.04em] mb-8 leading-relaxed">
                GAZ supports the UAE's Net Zero 2050 Strategy and the Dubai
                Clean Energy Strategy by integrating energy-efficient
                technologies into our operations. As a licensed gas distributor,
                we are committed to ensuring safe, sustainable, and efficient
                energy supply in alignment with national climate goals.
              </p>

              <ul className="space-y-4">
                {checkpoints.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <svg
                      className="w-6 h-6 mt-0.5 flex-shrink-0"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle cx="12" cy="12" r="12" fill="#1a7a4f" />
                      <path
                        d="M7 12.5L10.5 16L17 9"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-[16px] md:text-[20px] text-[#090d2c] tracking-[-0.04em] font-medium">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Image column */}
          <Reveal>
            <div className="rounded-[24px] overflow-hidden">
              <img
                src={rectangleImg}
                alt="Climate vision alignment"
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ClimateVisionSection;
